import React, { useState, useEffect } from 'react';
import Mobile from "../../component/mobile/mobile";
import { Link, useParams } from 'react-router-dom';
import { Button, Card, Col, Form, InputGroup, Row, Dropdown, Container } from 'react-bootstrap';
import { CiLocationOn } from "react-icons/ci";
import { FaSearch } from "react-icons/fa";
import { IoFilter } from "react-icons/io5";
import { FaAngleDown } from "react-icons/fa6";
import './vendor.css';
import { EquipmentVendorDetails } from "../../env/action";

export default function Vendor() {
    const { subservice_id } = useParams();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [equipmentVendors, setEquipmentVendorDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        setLoading(true);
        EquipmentVendorDetails((res) => {
            if (res?.status === 1) {
                setEquipmentVendorDetails(res.data);
            } else {
                alert("Error: No data found");
            }
            setLoading(false);
        });
    }, []);

    const filteredEquipmentsVendors = equipmentVendors.filter((item) =>
        item.dist?.toLowerCase().includes(searchQuery.toLowerCase())
    );


    return (
        <>
            <div style={{ backgroundColor: '#F9F9F9' }}>
                <div className="container mb-5 homeattend">

                    <Container>
                        {/* 🔍 Search Bar */}
                        <Row className="mb-3">
                            <Col md={12} className="my-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Search District"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </Col>
                        </Row>

                        <div className="row mb-4">
                            <h4>Medical Equipment</h4>
                        </div>
                    </Container>

                    {/* VENDOR LIST */}
                    <div className="mt-3">
                        <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">
                            {filteredEquipmentsVendors.map((vendor, index) => (
                                <Col key={index} className="p-2">
                                    <Card className="w-100 border rounded-2">

                                        {/* FIXED IMAGE */}
                                        <Card.Img src={vendor.image} className="card-img-top w-100" />

                                        <Card.Body>
                                            <Card.Text className="fw-bolder m-0" style={{ fontSize: '14px' }}>
                                                {vendor.company_name}
                                            </Card.Text>

                                            <div className="d-flex">
                                                <CiLocationOn className="fs-2 mt-1" />
                                                <p className="mt-2" style={{ fontSize: '12px', marginLeft: '10px' }}>
                                                    {vendor.address}, {vendor.city}, {vendor.dist}, {vendor.state}, {vendor.pincode}
                                                </p>
                                            </div>

                                            {/* FIXED DYNAMIC ROUTE */}
                                            <Link to={`/medicalequipment/${subservice_id}/${vendor.vendor_id}`}>
                                                <Button variant="light" className="btn w-100 border-black">View</Button>
                                            </Link>
                                        </Card.Body>

                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>

                <Mobile />
            </div>
        </>
    );
}
